import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { graphql } from "gatsby"
import styled from "@emotion/styled"
import Layout from "components/Layout"
import WorkCard from "components/WorkCard"

const WorkWrapper = styled("div")`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(24rem, 1fr));
  column-gap: 80px;
  row-gap: 80px;

  margin-bottom: 59px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    margin: 128px 32px 64px 32px;
  }
`

const Work = ({ works, meta }) => (
  <>
    <Helmet
      title={`Artworks | Script Art`}
      titleTemplate={`%s | ${meta.title}`}
      meta={[
        {
          name: `description`,
          content: meta.description,
        },
        {
          property: `og:title`,
          content: `Work | works | Events`,
        },
        {
          property: `og:description`,
          content: meta.description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: meta.author,
        },
        {
          name: `twitter:title`,
          content: meta.title,
        },
        {
          name: `twitter:description`,
          content: meta.description,
        },
      ].concat(meta)}
    />
    <Layout>
      <WorkWrapper>
        {works.map((work, i) => (
          <WorkCard
            key={i}
            title={work.node.work_title}
            thumbnail={work.node.work_gallery[0].gallery_image.url}
            uid={work.node._meta.uid}
            date={work.node.work_date}
            material={work.node.work_material}
            width={work.node.work_width}
            height={work.node.work_height}
          />
        ))}
      </WorkWrapper>
    </Layout>
  </>
)

export default ({ data }) => {
  const works = data.prismic.allWorks.edges
  const meta = data.site.siteMetadata
  if (!works) return null

  return <Work works={works} meta={meta} />
}

Work.propTypes = {
  works: PropTypes.array.isRequired,
}

export const query = graphql`
  {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
    prismic {
      allWorks {
        edges {
          node {
            _meta {
              uid
            }
            work_artist_name
            work_date
            work_description
            work_gallery {
              gallery_image
            }
            work_height
            work_material
            work_title
            work_width
          }
        }
      }
    }
  }
`
